import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { ServiceModel } from "../../types/ServiceModel";

@Injectable({
    providedIn: 'root'
})
export class ServiceService extends RestServiceBase<ServiceModel> {
    constructor() { super("ServiceModel"); }

    public async close(service: ServiceModel, folgetermin: Date | null): Promise<ServiceModel> {
        return await this.postHttpRequest(this.baseUri + '/close', { Service: service, FollowUp: folgetermin });
    }
}
